var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('create-item-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }